import { computed } from 'vue';
import { fetchMe } from '@/api/sentinel';
import { isNullOrUndefined } from 'shared/lib/object/object';
import { useStore } from 'vuex';

export default function useMe() {
  const store = useStore();

  const me = computed(() => store.state.me);

  // Re-fetch the sentinel /me snapshot mid-session (sentinel is the authority on MeResponse)
  // after an operation that changes a field it carries — e.g. a membership activating.
  const refreshMe = () => fetchMe().then((response) => {
    if (response?.status !== 200) {
      return null;
    }
    store.commit('ME_REFRESHED', response.data);
    return response.data;
  });
  const currentTenant = computed(() => store.state.currentTenant);
  const reachableAccounts = (me) => (me?.users ?? [])
    .filter((user) => !isNullOrUndefined(user.account))
    .map((user) => ({ ...user.account, activatedAt: user.activatedAt }));

  const lastActiveAccount = (me) => reachableAccounts(me)
    .find((account) => account.uid === me?.lastActiveTenant?.uid);

  const appFeedbackHistory = (me) => me?.appFeedback ?? { lastAskedAt: null, lastAnsweredAt: null };

  return {
    me,
    refreshMe,
    currentTenant,
    reachableAccounts: computed(() => reachableAccounts(me.value)),
    lastActiveAccount: computed(() => lastActiveAccount(me.value)),
    appFeedbackHistory: computed(() => appFeedbackHistory(me.value)),
  };
}
